import {
  EStreamRecordDownloadStatus,
  EStreamRecordStatus,
  TStreamRecord
} from '@/api/schema';
import { formatTimeDuration } from '@/helpers/timeDurationHelper';

export const DOWNLOAD_STATUS_POLLING_INTERVAL = 30000;

export const PREPARING_DOWNLOAD_STATUSES = [
  EStreamRecordDownloadStatus.REQUESTED,
  EStreamRecordDownloadStatus.PREPARING
];

export const DISABLED_DOWNLOAD_RECORD_STATUSES = [
  EStreamRecordStatus.INITIALIZED,
  EStreamRecordStatus.RECORDING,
  EStreamRecordStatus.ERROR
];

export const isPreparingDownloadStatus = (
  downloadStatus?: EStreamRecordDownloadStatus
): boolean => {
  return (
    !!downloadStatus && PREPARING_DOWNLOAD_STATUSES.includes(downloadStatus)
  );
};

export const isReadyDownloadStatus = (
  downloadStatus?: EStreamRecordDownloadStatus
): boolean => {
  return downloadStatus === EStreamRecordDownloadStatus.READY;
};

export const isDisabledDownloadRecordStatus = (
  status: EStreamRecordStatus
): boolean => {
  return DISABLED_DOWNLOAD_RECORD_STATUSES.includes(status);
};

export const isReadyRequestDownloadStatus = (
  streamRecord: TStreamRecord
): boolean => {
  return (
    !streamRecord.downloadStatus ||
    streamRecord.downloadStatus === EStreamRecordDownloadStatus.FAILED
  );
};

export const formatDuration = (
  startTime?: string,
  endTime?: string
): string => {
  if (!startTime || !endTime) return '-';

  const start = new Date(startTime.replace(' ', 'T')).getTime();
  const end = new Date(endTime.replace(' ', 'T')).getTime();

  if (Number.isNaN(start) || Number.isNaN(end)) return '-';

  return formatTimeDuration(Math.floor((end - start) / 1000));
};
